import React from "react";
import { Instagram, Linkedin, Youtube } from "lucide-react";
import { useSettings } from "../context/SettingsContext";

const withHttp = (url) => (/^https?:\/\//i.test(url) ? url : `https://${url}`);

export const useSocialLinks = () => {
  const { settings } = useSettings();
  return [
    { key: "instagram", url: settings.instagram_url, Icon: Instagram, label: "Instagram" },
    { key: "linkedin", url: settings.linkedin_url, Icon: Linkedin, label: "LinkedIn" },
    { key: "youtube", url: settings.youtube_url, Icon: Youtube, label: "YouTube" },
  ]
    .filter((s) => (s.url || "").trim())
    .map((s) => ({ ...s, url: withHttp(s.url.trim()) }));
};

const THEMES = {
  dark: "border-white/15 text-white/70 hover:text-charcoal hover:bg-gold hover:border-gold",
  light: "border-green/15 text-green hover:text-white hover:bg-green hover:border-green",
};

const SIZES = {
  compact: { box: "w-9 h-9 sm:w-10 sm:h-10", icon: "w-[18px] h-[18px] sm:w-5 sm:h-5", gap: "gap-1.5" },
  md: { box: "w-10 h-10", icon: "w-4 h-4", gap: "gap-3" },
  lg: { box: "w-14 h-14 sm:w-16 sm:h-16", icon: "w-6 h-6 sm:w-7 sm:h-7", gap: "gap-3 sm:gap-4" },
};

export const SocialLinks = ({ theme = "dark", compact = false, size, className = "", place = "footer", only }) => {
  const all = useSocialLinks();
  const links = only ? all.filter((s) => only.includes(s.key)) : all;
  const sz = SIZES[size || (compact ? "compact" : "md")];
  if (!links.length) return null;
  return (
    <div className={`flex items-center ${sz.gap} ${className}`} data-testid={`social-links-${place}`}>
      {links.map(({ key, url, Icon, label }) => (
        <a
          key={key}
          href={url}
          target="_blank"
          rel="noreferrer noopener"
          aria-label={label}
          title={label}
          data-testid={`social-${place}-${key}`}
          className={`${sz.box} rounded-full border flex items-center justify-center transition-colors ${THEMES[theme]}`}
        >
          <Icon className={sz.icon} />
        </a>
      ))}
    </div>
  );
};
